import React from "react";
import "./CommonButton.css";

const CommonButton = ({ text, type, className, link }) => {
  return <button className="box">{text}</button>;
};

export default CommonButton;
